export function changeOrdersStatus(orders, ordersIds, status) {
    return orders.map(order => {
        if (ordersIds.includes(order.id)) {
            const newOrder = {...order, status: status};

            if (status !== "SCHEDULED_READY" && "minutesTillReady" in newOrder)
                delete newOrder["minutesTillReady"];

            return newOrder;
        }

        return order;
    });
}